export * from './CountryPhoneCodes';
export * from './sidebar.const';
export const customer_module_feature_key = 'ftr_cutsomer_module';
export const sla_code_coverage_key = 'ftr-sla-v2';
export const sla_default_feature_key = "sla";
export const sla_custom_feature_key = "ftr-sla-custom"
export const customer_contact_directory_feature_key = 'ftr-customer-directory';
export const DC_FEATURE_KEY = 'ftr-domain-collaboration';
export const kb_feature_key = 'rls_knowledge_base';
export const advance_automation_feature_key = 'ftr-advanced-automations';
export const advance_automation_m4_feature_key = 'advanced-automations-m4';
export const advance_automation_m3_feature_key = 'advanced-automations-m3';
export const advance_automation_m5_feature_key = 'advanced-automations-m5';
export const body_search_feature_key = 'ftr-body-search';
export const assign_among_automation_feature_key = 'ftr-assign-among-automation';
export const trial_addon_event = 'ft_upg_feat';
export const voice_channel_selected_event = 'VoiceChannelSelected';
export const TRIAL_ADDON_FEATURE_KEY = 'ftr_trial_addon';
export const APPROVALS_FEATURE_KEY = 'ftr-finance-approvals';
export const APPROVALS_PLAN_FEATURE_KEY = 'ftr-finance-approvals-plan';
export const CONVERSATION_ID_FEATURE_KEY = 'conversation-id';
export const SM_CHAT_SUPPORT_FEATURE_KEY = 'ftr-sm-chat-support';
export const LANDING_PAGE_REVAMP_FEATURE_KEY = 'ftr-landing-page-revamp';
export const LANDING_PAGE_REVAMP_M2_FEATURE_KEY = 'ftr-landing-page-revamp-m2';
export const PRICING_PAGE_REVAMP_2023_FEATURE_KEY = 'pricing-revamp-2023';
export const PRICING_PAGE_REVAMP_2024_FEATURE_KEY = 'rls-pricing-revamp-2024';
export const PRICING_PAGE_REVAMP_2024_V2_FEATURE_KEY = 'rls-pricing-revamp-2024-v2';
export const POWERED_BY_HIVER_FOOTER_FEATURE_KEY = 'ftr-powered-footer';
export const POWERED_FOOTER_BLACKLIST_FEATURE_KEY = 'ftr-powered-footer-blacklist';
export const SHARED_LABEL_FEATURE_KEY = 'ftr-shared-label';
export const SHARED_LABEL_REVAMP_FEATURE_KEY = 'rls-sl-revamp';
export const CHAT_INTEGRATION_FEATURE_KEY = 'chat_integration';
export const AIRCALL_INTEGRATION_FEATURE_KEY = 'ftr-aircall-integration';
export const WHATSAPP_INTEGRATION_FEATURE_KEY = 'ftr-whatsapp-integration';
export const PLG_DIRECT_URL_FEATURE_KEY = 'ftr-plg-direct-url';
export const PREFILL_TEMPLATE_FEATURE_KEY = 'ftr-prefill-automation-template';
export const EXPLORE_YOUR_PLAN_M2_FEATURE_KEY = 'ftr-explore-your-plan-m2';
export const EXPLORE_YOUR_PLAN_M3_FEATURE_KEY = 'ftr-explore-your-plan-m3';
export const EXPLORE_YOUR_PLAN_M4_FEATURE_KEY = 'ftr-explore-your-plan-m4';
export const SALESFORCE_FEATURE_KEY = 'rls-salesforce-integration';
export const CHATBOT = 'Chatbot';
export const BOT_CONFIGURATION = 'Bot configuration';
export const AI_SUGGESTIONS = 'AI Openers';
export const KB_ARTICLES_IN_CHAT = 'Help articles in chat';
export const LIVE_CHAT_CONFIGURATION = 'ftr-live-chat-customizations'
export const NewBadgeScreens = [];
export const BUDDY_ANALYTICS_ENV = 'buddy-analytics';
export const BUDDY_LOCAL_ENV = 'dev';
export const BUDDY_ANALYTICS_API_BASE_URL = 'https://dev-analytics.hiver.space';
export const BUDDY_LOCAL_API_BASE_URL = 'https://dev.hiver.space/api/analytics';
export const BUDDY_LOCAL_V2_URL = 'https://v2dev.hiver.space';
export const USER_STATUS_PENDING = 'pending';
export const HFO_TRIAL_PLAN = 2000;
export const HCX_TRIAL_PLAN = 30;
export const TRIAL_PLANS = [HCX_TRIAL_PLAN, HFO_TRIAL_PLAN];
export const HIGHER_PLAN_TRIAL_STATE = {
    ACTIVE: 'active',
    EXPIRED: 'expired'
};
export const INTEGRATION_SIDEBAR_CONFIG = {
    label: 'Integrations',
    features: ['rls-asana-integration', 'rls-jira-integration', 'ftr-quickbooks-integration', 'rls-salesforce-integration', 'ftr-slack-integration'],
};
export const TAGS = 'tags';
export const SL_LEFT_NAV_CLICKED = 'ad_leftnav_clickedSL';
export const CHAT_BUSINESS_HOURS_RELEASE_KEY = 'rls-chat-business-hours';
export const CHECKLIST_UPDATE_CUSTOM_EVENT_KEY = 'checklist-update-event';
export const SIDEBAR_ITEM_CLICKED = "admin_panel_sidebar_clicked";

export const INSTRUMENTATION_TRACKING_EVENTS = {
    FirstSMFlow_BackToGmail: 'FirstSMFlow_Back to Gmail',
    FirstSMFlow_Step1: 'FirstSMFlow_Step1',
    FirstSMFlow_Step2: 'FirstSMFlow_Step2',
    LandedOnAdminPanel: 'LandedOnAdminPanel',
    SMFlow_Step1: 'SMFlow_Step1',
    SMFlow_Step2: 'SMFlow_Step2',
    FirstEmailSMCreated: 'FirstEmailSMCreated',
    AddedUGUser: 'AddedUGUser',
    AddedSMUser: 'AddedSMUser',
    removedSMUser: 'removedSMUser',
}
//Feature key to wrap the UI changes of AI Summariser
export const AI_SUMMARIZER_UI_FEAT_KEY = "temp-ai-summarizer-feature-key";

export const AI_SUMMARIZER_FEAT_KEY = "ftr-conversation-summary";
export const ADD_NEW_USER_FEAT_KEY = "ftr-add-new-user"
export const csat_feature_key = 'csat';
export const okta_integration_feature_key = 'sso-integration';
export const zapier_feature_key = 'rls-new-zapier'
export const harvey_feature_key = 'ftr-thankyou-detection'
export const harvey_template_suggestions = 'ftr-template-suggestions'
export const chat_contact_from_feature_key = 'ftr-chat-contact-form'
export const chat_nudges_feature_key = 'rls-chat-nudges'
export const remove_converstion_feature_key = 'ftr_download_report_removed_conversations'
export const new_automation_feature_key = 'ftr-new-automations-v1'
export const auto_response_feature_key = 'auto-response'
export const auto_assignment_feature_key = 'auto-assignment'
export const custom_role_feature_key = 'custom-roles'

export const INTEGRATION_NEWAUTH_FEAT_KEY = "rls-newauth-connect-service";
export const CHAT_NEWAUTH_FEAT_KEY = "rls-new-auth-channels-service";
export const SLA_NEWAUTH_FEAT_KEY = "rls-newauth-sla";
export const CUSTOMER_PORTAL_DEV_FEAT_KEY = "rls-customer-portal-v1"
export const CUSTOMER_PORTAL_FEAT_KEY = "ftr-customer-portal-v1"
export const ONBOARDING_CHECKLIST_KEY = "ftr-onboarding-checklist";
export const AUTOMATIONS_NEWAUTH_FEATURE_KEY = "rls-newauth-automations";
export const HIVERAPI_DOMAIN_FEATURE_KEY = "rls-hiver-api-domain";
export const GROUP_TYPE_SM_SOURCE_USER_FIX_FEAT_KEY = "rls-group-type-sm-source-user-fix";
export const SEAT_CONTRACTION_MODAL_RELEASE_KEY = "rls-seat-contraction-modal";
export const ACCOUNT_DELETION_FORM_RELEASE_KEY = "rls-account-deletion-form";
export const CUSTOM_FIELDS_DEV_FEAT_KEY = "rls-custom-fields";
export const TIME_BASED_AUTOMATIONS = 'ftr-time-based-automations';
export const CUSTOM_FIELDS_FEAT_KEY = "ftr-custom-fields"
export const CSAT = "csat";
export const CSAT_ENHANCEMENT = "csat-enhancement-fe";
export const CHAT_TRANSCRIPTS = "ftr-chat-transcripts";

export const ZAPIER_TRACKING_EVENTS = {
    ZAPIER_ENABLED:'zapEnabled',
    ZAPIER_ADMIN_CARD_CLICK:'zapAdminCardClicked',
    ZAPIER_ADMIN_CARD_LEARN_MORE:'zapAdminCardLearnMore',
};
export const CONNECTOR_TRACKING_EVENTS = {
    ADMIN_CONNECTOR_TAB_CLICK:'adminConnectorClicked',
    CONNECTOR_CONFIGURATION_ICON_CLICK:'connectorConfigClicked',
    CONNECTOR_COPY_ICON_CLICK:'connectorCopyKeyClicked',
    CONNECTOR_REGENERATE_KEY_CLICK:'connectorGenKeyClicked',
};
export const CUSTOM_CONNECTOR_EVENTS = {
    CARD_CLICKED: 'custom_connectors_card_clicked',
    MENU_CLICKED: 'custom_connectors_menu_clicked'
}
export const VOICE_TRACKING_EVENTS = {
    VOICE_ADMIN_CARD_CLICK: 'voiceAdminCardClicked',
};

export const AI_SUGGESTIONS_GS_EVENTS = {
    AI_SUGGESTION_SECTION_CLICKED: "ai_suggestion_section_clicked"
}

export const CONNECTORS_IN_AUTOMATION_KB_LINK = "https://help.hiverhq.com/productivity/using-automations"

export const FEEDBACK_FORM_FEATURE_KEY = 'ftr-feedback-form';

export const ACCOUNT_DELETION_DESCRIPTION = 'rls-plg-account-deletion-description';

export const SM_TYPE_SIGNUP_FLOW_KEY = 'rls-sm-type-signup-flow';

export const OUT_OF_OFFICE_SETTINGS_FK = 'rls-out-of-office-setting';

export const PRECHAT_FORM_COUNTRY_CODE_FEATURE_KEY = "ftr-prechat-form-country-code";

export const AUTOMATION_NEW_UI_FK = 'automations-enhancement-fe';

export const FREEMIUM_PLAN_FK = 'rls-freemium-plan';

export const CUSTOM_DOMAIN_FEATURE_KEY = 'ftr-customer-portal-custom-domain';

export const CUSTOM_DOMAIN_RELEASE_KEY = 'rls-customer-portal-custom-domain';

export const CSAT_MIGRATION = 'ftr-csat-migration';

export const CUSTOM_FIELDS_AUTOMATION_FEAT_KEY = 'ftr-custom-field-automations';

export const ADD_FOLLOWERS_THROUGH_AUTOMATIONS = 'ftr-adding-followers-through-automations';

export const CUSTOM_CONNECTORS_FEATURE_KEY = 'ftr-connectors-enabled';

export const CONVERSATION_FOLLOWERS_FK = 'ftr-conversation-follower';

export const PLG_OUT_OF_OFFICE_NUDGE = 'ftr-plg-out-of-office-nudge';

export const OUT_OF_OFFICE = 'ftr-out-of-office';

export const JOIN_HIVER_COMMUNITY_FK = 'ftr-join-hiver-community';

export const PROMOTIONAL_BANNER_FK = 'ftr-promotional-banner';

export const ONBOARDING_JOURNEY_30DAYS = 'ftr-onboarding-journey-30days';

export const KNOWLEDGE_BASE_UPGRADED_TAG_FEAT_KEY = 'ftr-kb-upgraded-tag';

export const AUTOMATIONS_ADD_DELETE = 'ftr-automations-add-delete';

export const LAST_100_MAIL_SYNC = 'ftr-100-mail-sync';

export const GROWTH_24_PLAN_FK = 'rls-2024-growth-plan';

export const APPROVALS_IN_AUTOMATION = 'ftr-approvals-automations';

export const AI_REPHRASE_RELEASE_KEY = 'rls-ai-rephrase';

export const AI_REPHRASE_FEATURE_KEY = 'ftr-ai-rephrase';

export const MANDATORY_CUSTOM_FIELD_FEATURE_KEY = 'ftr-cf-mandatory-on-close';

export const CUSTOM_FIELD_TIMEZONE_INSENSITIVE = 'custom_field_timezone_insensitive';

export const CUSTOM_CONNECTORS_BLUE_DOT_FEATURE_KEY = 'ftr-connector-blue-dot';

export const CONNECTORS_LOCALSTORAGE_KEY = 'hiver_connectors';

export const SCHEDULED_AUTOMATIONS = 'ftr-schedule-automation';

export const PRICING_PAGE_REVAMP_2025 = 'rls-pricing-revamp-2025';

export const SLA_PLG_NUDGE2_PART1_FK = 'rls-plg-sla-nudge2-p1';

export const SLA_PLG_NUDGE2_PART2_FK = 'rls-plg-sla-nudge2-p2';

export const AI_BLACKLIST = 'ftr-ai-blacklist';

export const AI_COPILOT = 'ftr-ai-copilot';
export const AI_SETTINGS = 'rls-ai-settings';
export const AI_TAGGING = 'ftr-ai-tagging';
export const AI_COPILOT_V2 = 'rls-ai-copilot-v2';
export const AI_COPILOT_PAST_CONV = 'rls-ai-copilot-past-conv'
export const AI_COPILOT_UPLOAD_SOURCE = 'rls-ai-copilot-upload-doc-source'
export const AI_COPILOT_UPLOAD_LIMIT_INC = 'rls-ai-copilot-30mb-docs'
export const AI_COPILOT_LIBRARY = 'rls-ai-coplilot-library'
export const AI_TEMPLATE_SUGGESTIONS = 'ftr-ai-template-suggestions'




export const CONNECTORS_IN_AUTOMATION = 'ftr-connector-automations'

export const MICROSOFT_CLARITY_INTEGRATION = 'rls-microsoft-clarity-integration';
export const CUSTOMER_PORTAL_STATIC_FIELDS= 'ftr-customer-portal-static-fields';

export const UG_STATE = {
    ACTIVE :"active",
    TRIAL: "trial",
    SUSPENDED: "suspended",
};

export const EXTEND_TRIAL_GAINSIGHT_EVENT_KEY = "Extend_Trial_Clicked";
export const EXTEND_TRIAL_SUPPORT_GS_EVENT_KEY = "Extend_Trial_Support_Clicked";

export const STRIPE_SCA_ENABLED_FK = 'ftr-stripe-sca'

export const TRIAL_MAIL_SYNC_FIX = 'rls-sm-mail-sync-status';

export const AI_ADOPTION_GUIDERS_FK = 'rls-ai-adoption-guiders';

export const FIRST_AI_KB_SOURCE_ADDED = "first_ai_kb_source_added";

export const AI_COPILOT_DOWNLOAD_LINKS_FK = 'rls-ai-copilot-download-links';

export const AI_TAGS_DESCRIPTION = 'ftr-tags-description';

export const CHATBOTS_AUTO_SAVE = 'ftr-chatbots-autosave';
export const DAY_TIMEZONE_SELECT = 'day-time-zone-flag';
export const AUTORESPONDER_EXCLUDE_DOMAIN = 'autoresonder-exclude-domain';

export const AI_COPILOT_ADOPTION_BANNER = 'rls-ai-copilot-adoption-banner';

export const CONNECTORS_UNIFIED_VIEW_FEAT_KEY = "ftr-connector-unified-view";

export const INTEGRATION_GROUP_EVENTS = {
    INTEGRATION_MENU_CLICKED: 'integration_menu_click',
    APPS_CARD_CLICKED: 'admin_home_apps_card_clicked',
    DEVELOPER_API_CARD_CLICKED: 'admin_home_dev_api_card_clicked',
    INTEGRATION_SUBMENU_CLICKED: 'integration_submenu_click',
    APPS_MENU_CLICKED: 'integration_app_page_load',
    DEVELOPER_API_MENU_CLICKED: 'integration_developer_page_loaded',
}

export const INTEGRATION_DROPDOWN_SUBTABS = {
    APPS: '/app/custom-connectors',
    DEVELOPER_APIS: '/app/developer',
};

export const DEVELOPER_FEATURE_API_KEY = "ftr-openApi";
export const DEVELOPER_RELEASE_API_KEY = "rls-openapi";

export const TIERED_PRICING_REVAMP_FEATURE_KEY  = 'rls-tiered-pricing-revamp-2025';

export const REPLY_TO_EMAIL_ACTION = 'ftr-reply-to-email-action';

export const CUSTOM_OBJECTS_RELEASE_KEY = 'rls-custom-objects';
export const CUSTOM_OBJECTS_FEATURE_KEY = 'ftr-custom-objects-automations';

export const AI_CUSTOM_FIELDS_FEATURE_KEY = 'ftr-ai-custom-fields';

export const CUSTOM_FIELDS_TYPES = {
    DROPDOWN: 'DROPDOWN',
    NUMBER: 'NUMBER',
    DATE: 'DATE',
    TEXT: 'TEXT',
};

export const PI_AUTOMATIONS_FEATURE_KEY = 'ftr-pi-to-sm-automations';
export const CSAT_ADVANCED_SETTINGS = "ftr-csat-advanced-settings";
export const AI_AUTO_TAGGING_FEATURE_KEY = 'ftr-ai-auto-tagging';
export const AI_AUTO_TAGGING_V2_FEATURE_KEY = 'ftr-ai-auto-tagging-v2';

export const AI_AUTO_TAGGING_DISCOVERABILITY_GUIDERS = 'ftr-ai-auto-tagging-discoverability-guiders';

export const SCROLL_QUERY_STRING = 'scrollElementId';
export const SCROLL_HIGHLIGHT_QUERY_STRING = 'scrollHighlightElementId';
export const AI_CUSTOM_FIELD_GUIDER_FEATURE_KEY = 'rls-ai-custom-field-guider';